import classes from './ChartCustomTooltip.module.css';

type ChartCustomTooltipProps = {
  children: React.ReactNode;
  active: boolean;
};

export const ChartCustomTooltip = ({
  children,
  active,
}: ChartCustomTooltipProps) => {
  return (
    active && (
      <div
        className={classes.tooltipcontainer}
        role="tooltip"
        id="customTooltip"
      >
        {children}
      </div>
    )
  );
};
